import { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { ComponentSettings } from '../ComponentSettings/ComponentSettings';
import { useAtomValue } from 'jotai';
import * as analysisState from '@/components/Analysis/state';

type ComponentSettingsProps = {
  variant?: 'lg' | 'sm';
};

export const ComponentSettingsButton = ({ variant = 'sm' }: ComponentSettingsProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const selectedAssemblyIds = useAtomValue(analysisState.selectedAssemblyIds);

  return (
    <>
      <Tooltip
        title={
          selectedAssemblyIds.length === 0 ? 'Select at least one component' : 'Component settings'
        }
        arrow
        placement="left"
      >
        <span>
          <Button
            variant="outlined"
            size={variant === 'lg' ? 'large' : 'small'}
            startIcon={<AbyssIcon iconName="gear-outlined" size={variant === 'lg' ? 'lg' : 'md'} />}
            onClick={() => setIsOpen(true)}
            disabled={selectedAssemblyIds.length === 0}
            fullWidth={variant === 'lg'}
            id={`${location}-generate-report-button`}
          >
            <Stack direction="row" alignItems="center" gap="0.8rem">
              <span>Component Settings</span>
              <AbyssIcon iconName="beta" size={variant === 'lg' ? 'md' : 'sm'} />
            </Stack>
          </Button>
        </span>
      </Tooltip>
      {isOpen && (
        <ComponentSettings
          selectedAssemblyIds={selectedAssemblyIds}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
};
